import { SeoPromotion, SeoPromotionData } from 'shared/analytics/promotion'
import { SeoListName } from 'shared/analytics/types'
import { LocalStorage } from 'shared/utils/storage'

export interface SeoCreativeData {
  productId: string
  promotion: SeoPromotionData | undefined
  listName: SeoListName
}

interface AddProductSeoToLocalstorage {
  productId: string
  listName: SeoListName
}

const SEO_CREATIVE_DATA_KEY = 'seo_creative_data'

export class ProductSeoStorage {
  private static storage = new LocalStorage(SEO_CREATIVE_DATA_KEY)

  static clear(): void {
    ProductSeoStorage.storage.set([])
  }

  static get(): SeoCreativeData[] {
    return ProductSeoStorage.storage.get<SeoCreativeData[]>([])
  }

  static find(productId: string): SeoCreativeData | undefined {
    const creativeData = ProductSeoStorage.get()

    if (!Array.isArray(creativeData)) {
      return undefined
    }

    return creativeData.find(item => item?.productId === productId) || undefined
  }

  static add({ productId, listName }: AddProductSeoToLocalstorage): void {
    const storedItems = ProductSeoStorage.get()

    const newItem: SeoCreativeData = {
      productId,
      listName,
      promotion: SeoPromotion.get()
    }

    const foundItem = storedItems.find(item => item.productId === productId)

    if (!foundItem) {
      storedItems.push(newItem)
      ProductSeoStorage.storage.set(storedItems)
    }
  }

  static remove(productId: string): void {
    const storedItems = ProductSeoStorage.get()

    const filteredItems = storedItems.filter(
      item => item.productId !== productId
    )

    ProductSeoStorage.storage.set(filteredItems)
  }
}

export const bannersStorage = new LocalStorage('banners')
